import { Input, InputProps } from "./Input"

export const OTPInput = (props: InputProps) => {
  return (
    <Input
      {...props}
      onInput={(e) => {
        let value = e.currentTarget.value
        value = value.replace(/\D/g, "").slice(0, 9)
        if (value.length > 3 && value.length <= 6) {
          value = value.replace(/(\d{3})(\d{0,3})/, "$1-$2")
        }
        if (value.length > 6) {
          value = value.replace(/(\d{3})(\d{3})(\d{0,3})/, "$1-$2-$3")
        }
        e.currentTarget.value = value
      }}
    />
  )
}
